/* eslint-disable consistent-return */

import getProductConfig from '@services/menu/getProductConfig';
import { successAction } from '@utils/actions';
import { errorAction, redirect } from '@shared/actions';
import { mapperProductConfig } from '@services/menu/productConfig/mapperProductConfig';
import getShopBusinessType from '@core/reducers/shop/selectors/getShopBusinessType';
import isRestaurant from '@shopDetails/utils/isRestaurant';
import getCartIsPickUp from '@core/reducers/cart/selectors/getCartIsPickUp';
import { SHOP_DELIVERY_TYPE } from '@shared/constants';
import getShopDetailsRoute from '../utils/getShopDetailsRoute';
import * as actions from '../actionTypes';

const fetchProductConfig = ({
  productId,
  shopId,
  isFavourite = false,
  itemId = null,
  subsidizedProduct = null,
  discount = null,
  returnData = false,
}) => async (dispatch, getState, axios) => {
  const type = actions.FETCH_PROD_OPTIONS;

  try {
    const state = getState();
    const businessType = getShopBusinessType(state);
    const cartIsPickUp = getCartIsPickUp(state);
    const menuWithNiles = isRestaurant(businessType);

    dispatch({ type });

    const { success, data, error } = await getProductConfig({
      axios,
      productId,
      shopId,
      occasion: cartIsPickUp
        ? SHOP_DELIVERY_TYPE.PICK_UP
        : SHOP_DELIVERY_TYPE.DELIVERY,
    });

    if (success) {
      const product = mapperProductConfig(data);
      product.isFavourite = isFavourite;
      product.itemId = itemId;

      if (menuWithNiles) {
        product.subsidizedProduct = subsidizedProduct;
        product.applyDiscount = false;
        product.discount = discount;
      }

      dispatch(
        successAction({
          type,
          payload: {
            product,
          },
        }),
      );
      if (returnData) return product;
    } else {
      dispatch(redirect(getShopDetailsRoute()));
      dispatch(errorAction({ type, error, mute: true }));
    }
  } catch (error) {
    dispatch(errorAction({ type, error }));
  }
};

export default fetchProductConfig;
